import * as React from 'react';
import { styled } from '../theme';
import { ButtonType, ButtonWidget } from '../widgets/buttons/ButtonWidget';
import { HelperTextWidget } from '../widgets/forms/HelperTextWidget';
import { wrapLoadingAction } from '../utils/actions';
import { useSystem } from '../hooks/useSystem';
import { Layer } from '../layers/LayerManager';
import { BackupCodesDisplayWidget } from '../widgets/authentication/BackupCodesDisplayWidget';

export type SmartGenerateBackupCodesWidgetProps = {
  showMessage?: boolean;
};

namespace S {
  export const Container = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  export const GenerateButton = styled(ButtonWidget)`
    max-width: 250px;
  `;

  export const Text = styled(HelperTextWidget)`
    max-width: 350px;
  `;
}

export const SmartGenerateBackupCodesWidget: React.FC<SmartGenerateBackupCodesWidgetProps> = (props) => {
  const system = useSystem();

  return (
    <S.Container>
      <S.GenerateButton
        type={ButtonType.SECONDARY}
        action={async (event, loading) =>
          wrapLoadingAction(
            async () => {
              // Warn that generating new codes will invalidate old codes
              if (
                system.mfaStore.backupCodesViewed &&
                !(await system.dialogStore.confirmDialog({
                  message:
                    'Backup codes have already been generated. Generating new codes will invalidate the previous codes. Generate new codes?'
                }))
              ) {
                return;
              }

              const client = await system.clientProvisioner.provisionSensitiveUserHubClient();
              const response = await client.generateMFABackupCodes();

              system.layerManager.registerLayer(
                new Layer({
                  withBackdrop: true,
                  render: (event) => (
                    <BackupCodesDisplayWidget onClose={() => event.layer.dispose()} codes={response.backup_codes} />
                  )
                })
              );
            },
            loading,
            (error) => {
              console.error(error);
              system.dialogStore.errorDialog({ errorMessage: 'Could not download backup codes' });
            }
          )
        }
        label="Generate backup codes"
      />
      {props.showMessage ? (
        <S.Container>
          <S.Text>
            Backup codes will allow you to reset your authentication settings in the event you lose your device or
            cannot generate new codes.
          </S.Text>
        </S.Container>
      ) : null}
    </S.Container>
  );
};
